
export enum ReportsCd {
	D = 'D',
	S = 'S'}

